export default {
  namespaced: true,
  state: () => ({
    Prctr: '',
    Zftlx: ''
  }),
  mutations: {
    setPrctr(state, flag) {
      state.Prctr = flag;
    },
    setZftlx(state, flag) {
      state.Zftlx = flag;
    }
  },
  actions: {
    changePrctr({
      commit
    }, value) {
      commit('setPrctr', value);
    },
    changeZftlx({
      commit
    }, value) {
      commit('setZftlx', value);
    }
  }
};